export function requiredPlaceholder(_placeholder, suffix = "Required") {
    return suffix || "Required";
}

export function requiredLabel(label, isRequired = true) {
    return label || "";
}

export function isEmptyRequiredValue(value) {
    if (value === null || value === undefined) {
        return true;
    }
    if (typeof value === "string") {
        return value.trim() === "";
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    return false;
}

export function requiredFieldErrors({
    value,
    showValidationErrors,
    serverErrors = null,
    requiredMessage = "Required",
}) {
    if (serverErrors?.length) {
        return serverErrors;
    }
    if (showValidationErrors && isEmptyRequiredValue(value)) {
        return [requiredMessage];
    }
    return [];
}
